import { GEOLOCATION } from '../mutation-types'

const state = {
  location: {
    longitude: undefined,
    latitude: undefined,
    accuracy: undefined
  }
}

const getters = {
  location (state) {
    return state.location
  }
}

const mutations = {
  [GEOLOCATION] (state, position) {
    state.location.longitude = position.longitude
    state.location.latitude = position.latitude
    state.location.accuracy = position.accuracy
  }
}

export default {
  state,
  getters,
  mutations
}
